const initMutualFundPage = () => {
    const mutualFundPage = document.body.classList.contains('mutual-fund');
    const etfPage = document.body.classList.contains('etf');

    if (mutualFundPage) {
        handleSetMutualFundETF();
    }

    if (etfPage) {
        handleSetMutualFundETF();
    }

}

const handleSetMutualFundETF = () => {
    const excludedOption = document.querySelector('.gg-insights-filters').dataset.excludedItem;
    const mutualFundOptions = document.querySelectorAll(`[value="${excludedOption}"]`);
    const optionAll = document.querySelector('.gg-insights-filters option[hidden]');

    if (!optionAll || !mutualFundOptions) {
        return;
    } else {
        optionAll.style.display = 'block';
    }

    mutualFundOptions.forEach(option => {
        // option.textContent = 'All';
        option.setAttribute('disabled', true);
        option.style.display = 'none';
    });

    const selectElement = document.querySelector('.gg-insights-filters .gravity-block-filters__select');
    if (selectElement) {
        sortOptionsAlphabetically(selectElement);
    }
}

const sortOptionsAlphabetically = (selectElement) => {
    const options = Array.from(selectElement.options);
    options.sort((a, b) => a.text.localeCompare(b.text));
    selectElement.innerHTML = '';
    options.forEach(option => selectElement.add(option));
}

export default initMutualFundPage;
